export default "__VITE_ASSET__IWGlwPlV__"